<template>
  <div v-html='text'></div>
</template>

<script>
export default {
  name: 'InterviewFreeText',
  props: {
    text: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style scoped>

</style>
